import { all } from 'redux-saga/effects';
import { AppSaga } from './App';
import { DeveloperSaga } from './Developer';
import { AuthorizationSaga } from './Authorization';

export default function* rootSaga(): Generator {
	yield all([ AppSaga(), AuthorizationSaga(), DeveloperSaga() ]);
}